import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components

import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card'

import CreateIcon from '@material-ui/icons/Create'

import pic1 from 'assets/img/servicePage/1.png'
import pic2 from 'assets/img/servicePage/2.png'
import pic3 from 'assets/img/servicePage/3.png'
import pic4 from 'assets/img/servicePage/4.png'

import styles from 'assets/jss/material-kit-react/views/servicePageSections/designStyle.js'

const useStyles = makeStyles(styles)

export default function DesignSection() {
  const classes = useStyles()
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>
            <CreateIcon className={classes.titleIcon} />
            设计板块
          </h2>
        </GridItem>
      </GridContainer>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={3}>
          <Card className={classes.imgBackground} style={{ backgroundImage: `url(${pic1})` }}>
            <div className={classes.cardContent}>
              <h4>海绵城市规划设计</h4>
            </div>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card className={classes.imgBackground} style={{ backgroundImage: `url(${pic2})` }}>
            <div className={classes.cardContent}>
              <h4>雨水回收专项设计</h4>
            </div>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card className={classes.imgBackground} style={{ backgroundImage: `url(${pic3})` }}>
            <div className={classes.cardContent}>
              <h4>建筑信息化技术 BIM 应用</h4>
            </div>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card className={classes.imgBackground} style={{ backgroundImage: `url(${pic4})` }}>
            <div className={classes.cardContent}>
              <h4>综合能源管理平台设计</h4>
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  )
}
